import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { correlationIdSelector } from '../store/samoobsluga/samoobsluga.selectors';

export const CORRELATION_ID_HEADER_NAME = 'Correlation-Id';

@Injectable()
export class HeadersInterceptor implements HttpInterceptor {

  constructor(private store: Store) {
  }

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return this.store.select(correlationIdSelector).pipe(
      take(1),
      switchMap(id => {
        const headers: Record<string, string> = {};
        headers[CORRELATION_ID_HEADER_NAME] = id ?? '';
        const clonedRequest = request.clone({
          setHeaders: headers
        });
        return next.handle(clonedRequest);
      })
    );
  }
}
